export default __webpack_public_path__ + "static/media/darkLogo.8cf3815a.gif";